import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import "../../../../assets/scss/map-control.scss";
import { useDispatch, useSelector } from 'react-redux';
import { updateSettings } from '../../../actions/user';

export const RoundControl = ({ title, className, iconClassName, srcUrl, onClick, styles }) => {
    return <div
        title={title}
        className={`round-control ${className || ""}`}
        onClick={onClick}>
        {iconClassName ? <i className={iconClassName} /> : <img style={{ borderRadius: title === 'Seed History' ? '50px' : '100px', ...styles }} alt="" src={srcUrl}></img>}
    </div>;
};

export const MapTypeControl = ({ map, defaultType }) => {

    const userProps = useSelector(state => state.user.userSettings.user_properties);
    const dispatch = useDispatch();
    const mapType = userProps && userProps.map_type ? userProps.map_type : null;
    const types = { "Standard": 'roadmap', "Terrain": 'terrain', "Satellite": 'satellite', "Hybrid": 'hybrid' };
    const [value, setValue] = useState(mapType || defaultType || "satellite");

    const handleMaptType = (type) => {
        map.setOptions({ mapTypeId: types[type] });
        setValue(types[type]);
        dispatch(updateSettings({ userProperties: { ...userProps, map_type: types[type] } }));
    }

    return (<Dropdown
        drop="left"
        title="Map Type"
        className="square-control mt-2 dropdown-map-type"
    >
        <Dropdown.Toggle split variant="link">
            <i className="icon icon-layers fa" />
        </Dropdown.Toggle>
        <Dropdown.Menu className='animate animate__fadeIn'>
            {Object.keys(types).map((type, i) =>
                <Dropdown.Item
                    key={i}
                    active={(types[type] === mapType) ? value : undefined}
                    onClick={() => handleMaptType(type)}
                >
                    {type}
                </Dropdown.Item>)}
        </Dropdown.Menu>
    </Dropdown>);
};

export default { RoundControl, MapTypeControl };
